import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useMemo } from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import divisionActions from "../../../_actions/_qmsActions/divisionActions";
import qmsActionIsAuthorized from "./qmsAutorize";

export default function QmsDivisionSelector(props) {
  const { setDivision } = props;

  const dispatch = useDispatch();
  useEffect(() => dispatch(divisionActions.getAll()), []);

  // Fetched in QmsDashboard
  const DIVISION_SCOPE = useSelector((state) =>
    "DIVISIONS" in state.qms.permissionScopes
      ? state.qms.permissionScopes.DIVISIONS.name
      : null
  );

  const qmsUser = useSelector((state) => state.qms.qmsUser || null);
  const qrps = useSelector((state) => state.qms.qmsRolePermissions || null);
  const divisions = useSelector((state) => state.qms.divisions || null);
  const divisionOptions = useMemo(
    () =>
      (divisions || []).map((d) => ({
        label: `${d.name} (${d.abbreviation})`,
        value: d.divisionId,
      })),
    [divisions]
  );

  const [selectedDivision, selectDivision] = useState(null);
  useEffect(() => setDivision(selectedDivision), [selectedDivision]);

  const allowManageDivisions = useMemo(
    () => qmsActionIsAuthorized(DIVISION_SCOPE, "edit", 1),
    [DIVISION_SCOPE, qmsUser, qrps]
  );

  return (
    <div className="card mx-0 mt-0 mb-2 w-100 bg-lightgray">
      <div className="card-body p-2">
        <div className="form-row w-100">
          <label htmlFor="divisionSelector" className="mx-2 my-auto">
            <b>Division:</b>
          </label>
          <Select
            name="divisionSelector"
            id="divisionSelector"
            className="qms-admin-division-selector mr-2"
            value={selectedDivision}
            options={divisionOptions}
            onChange={selectDivision}
            styles={{
              // Fixes the overlapping problem of the component
              menu: (provided) => ({ ...provided, zIndex: 9999 }),
            }}
          />
          {allowManageDivisions && (
            <button
              name="editDivisions"
              id="editDivisions"
              className="btn btn-info"
              onClick={() => {}}
            >
              <FontAwesomeIcon icon="cogs" className="mr-2" />
              Manage Divisions...
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
